
export default function HeroSection() {
  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(30, 58, 138, 0.7), rgba(30, 58, 138, 0.5)), url('https://public.readdy.ai/ai/img_res/7495064e0aa78098dfbeb0be300c3eda.jpg')`
      }}
    >
      <div className="container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Your <span className="text-yellow-400">Sleep Health</span> Specialists in Sarasota
          </h1>
          <p className="text-xl md:text-2xl mb-8 leading-relaxed opacity-90">
            Professional CPAP & BiPAP equipment, masks, and supplies. 
            Helping you breathe better and sleep soundly every night.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a 
              href="tel:941.286.4000" 
              className="bg-yellow-400 hover:bg-yellow-300 text-blue-900 px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 whitespace-nowrap shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              <i className="ri-phone-fill mr-2"></i>
              Call (941) 286-4000
            </a>
            <a 
              href="#services" 
              className="border-2 border-yellow-400 text-yellow-400 hover:bg-yellow-400 hover:text-blue-900 px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 whitespace-nowrap"
            >
              View Our Services
            </a>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-yellow-400 text-2xl"></i>
      </div>
    </section>
  );
}
